/**
 * S-14 Today's Menu tab icon (V7-owned — screen-local composition lives in
 * the feature dir; the design system stays foundation-owned). Mirrors the
 * stroke conventions of design/icons.tsx: 24 viewBox, currentColor, 1.8.
 */
import type { SVGProps } from "react";

export function IconMenu(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      width={24}
      height={24}
      fill="none"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
      {...props}
    >
      {/* plate under a cloche — the daily picks */}
      <path d="M4 17h16" />
      <path d="M6 17a6 6 0 0 1 12 0" />
      <path d="M12 11V9" />
      <path d="M8.5 20h7" />
    </svg>
  );
}
